export type OrderRequestMessages = {
  orderCreateError: string;
  orderUpdateError: string;
  orderCreateSuccess: string;
  orderUpdateSuccess: string;
  cancelOrderSuccess: string;
};

export const ORDER_REQUEST_MESSAGES: OrderRequestMessages = {
  orderCreateSuccess: "Pedido criado com sucesso!",
  orderUpdateSuccess: "Pedido atualizado com sucesso!",
  orderCreateError: "Erro na criação do Pedido!",
  orderUpdateError: "Erro ao salvar o Pedido!",
  cancelOrderSuccess: "Pedido cancelado com sucesso",
};
